import React from 'react';
import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AlbumIcon from '@material-ui/icons/Album';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import useStyles from './style';

const noop = () => {};

const defaultState = {
  showErrors: false,
  showSuccess: false,
};

const Progess = ({
  errors = [],
  success = [],
  paperElevation = 4,
  progressPercent = 0,
  isRateLimited = false,
  rateLimitDelay = 60,
  isSyncing = false,
  hasPaused = false,
  onSyncPause = noop,
}) => {
  const classes = useStyles();
  const [state, setState] = React.useState(defaultState);

  return (
    <Paper className='mr-10 ml-10 p-6 mt-5' elevation={paperElevation}>
      <div className='d-flex f-align-center f-justify-between w-100'>
        <div></div>
        <Typography variant='body1' className='f-align-center text-bold mt-2'>
          {!!errors.length ? 'Sync Errors Found' : 'SYNCING CHANGES'}
        </Typography>
        <div>
          {(isSyncing || hasPaused) && (
            <Button
              variant='contained'
              color='primary'
              size='small'
              disabled={hasPaused}
              className={clsx('p-2', classes.pauseButton)}
              onClick={onSyncPause}
            >
              <AlbumIcon />
            </Button>
          )}
        </div>
      </div>
      <div className='d-flex w-100'>
        <LinearProgress
          variant='determinate'
          value={progressPercent}
          classes={{
            barColorPrimary: !!errors.length
              ? classes.errorColor
              : classes.successColor,
          }}
          className={clsx('mt-5 w-100', classes.progressBar)}
        />
      </div>
      <div className='mt-1'>
        <Typography variant='caption' className='color-grey'>
          {Math.floor(progressPercent)}%
        </Typography>
      </div>
      {isRateLimited && (
        <div className='d-flex f-align-center f-justify-center mt-4'>
          <Chip
            label={`Oops! Rate limit exceeded. Download will resume in ${rateLimitDelay} seconds.`}
            color='primary'
            className='mr-4 mt-2 mb-2 bg-secondary color-white'
          />
        </div>
      )}
      {!!success.length && (
        <div className='mt-4'>
          <Button
            disableRipple
            disableFocusRipple
            className={clsx(
              classes.successMessageColor,
              'bg-paper pl-0 pr-0 text-bold'
            )}
            endIcon={
              state.showSuccess ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />
            }
            onClick={() => {
              setState(prevState => ({
                ...prevState,
                showSuccess: !prevState.showSuccess,
              }));
            }}
          >
            Success
          </Button>
          <div className={clsx('mt-2', classes.overflow)}>
            {state.showSuccess &&
              !!success.length &&
              success.map(success => (
                <Typography
                  variant='body2'
                  className={clsx(classes.successMessageColor, 'mt-2')}
                >
                  {success.message}
                </Typography>
              ))}
          </div>
        </div>
      )}
      {!!errors.length && (
        <div className='mt-4'>
          <Button
            disableRipple
            disableFocusRipple
            className='color-error bg-paper pl-0 pr-0 text-bold'
            endIcon={
              state.showErrors ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />
            }
            onClick={() => {
              setState(prevState => ({
                ...prevState,
                showErrors: !prevState.showErrors,
              }));
            }}
          >
            Errors Found
          </Button>
          <div className={clsx('mt-2', classes.overflow)}>
            {state.showErrors &&
              !!errors.length &&
              [
                { message: 'There were some errors with your submission' },
                ...errors,
              ].map(error => (
                <Typography variant='body2' className='color-error mt-2'>
                  {error.message}
                </Typography>
              ))}
          </div>
        </div>
      )}
    </Paper>
  );
};

export default Progess;
